import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { DocumentService } from '@dealstack/frontend/shared/dataExchange/services/document/document.service';
import { DocumentsRes } from '@dealstack/frontend/shared/dataExchange/services/shared/types';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2';

export const usePreviewFile = () => {
	const tCapManage = useTranslationCapManage();
	const getDownloadPreSignedUrl = useMutation({
		mutationFn: DocumentService.getDownloadPreSignedUrl,
	});
	const [previewDocument, setPreviewDocument] = useState<{
		downloadUrl: string;
		fileExtension: string;
		fileName: string;
	}>();

	const previewFile = async (document: DocumentsRes, dealId: string) => {
		getDownloadPreSignedUrl.mutate(
			{
				dealId,
				fileId: document.fileId,
			},
			{
				onSuccess: async (data) => {
					if (data.payload?.downloadUrl) {
						setPreviewDocument({
							downloadUrl: data.payload.downloadUrl,
							fileExtension: document.fileExtension,
							fileName: document.name,
						});
						return;
					}

					showToastV2({
						title: tCapManage('documents.errors.download-document'),
						state: 'error',
					});
				},
				onError: () => {
					showToastV2({
						title: tCapManage('documents.errors.download-document'),
						state: 'error',
					});
				},
			}
		);
	};

	return {
		previewFile,
		previewDocument,
		setPreviewDocument,
	};
};
